
import React, { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faDownload, faSearch, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Nav, Form, Image, Navbar, Dropdown, Container, InputGroup, Button } from '@themesberg/react-bootstrap';
import { Link } from "react-router-dom";

import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { Routes } from "../routes";


export default (props) => {
  const userName = useMemo(() => {
    const stored = localStorage.getItem("treasurer.authUser");
    if (!stored) {
      return "Treasurer";
    }
    try {
      const parsed = JSON.parse(stored);
      return parsed.name || parsed.email || "Treasurer";
    } catch (error) {
      return "Treasurer";
    }
  }, []);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("beforeinstallprompt", handleInstallPrompt);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleInstallPrompt);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("treasurer.authToken");
    localStorage.removeItem("treasurer.authUser");
  };


  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex align-items-center">
            <Form className="navbar-search">
              <Form.Group id="topbarSearch">
                <InputGroup className="input-group-merge search-bar">
                  <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                  <Form.Control type="text" placeholder="Search" />
                </InputGroup>
              </Form.Group>
            </Form>
          </div>
          <Nav className="align-items-center">
            {!isOnline ? (
              <span className="text-warning small me-3">Offline</span>
            ) : null}
            {deferredPrompt ? (
              <Button variant="outline-primary" size="sm" className="me-3" onClick={handleInstallClick}>
                <FontAwesomeIcon icon={faDownload} className="me-2" />
                Install
              </Button>
            ) : null}
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <FontAwesomeIcon icon={faUserCircle} className="text-gray-500" size="2x" />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{userName}</span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                <Dropdown.Item as={Link} to={Routes.Settings.path} className="fw-bold">
                  <FontAwesomeIcon icon={faCog} className="me-2" /> Settings
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to={Routes.Signin.path}
                  className="fw-bold"
                  onClick={handleLogout}
                >
                  <FontAwesomeIcon icon={faSignOutAlt} className="text-danger me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
